import { render, staticRenderFns } from "./ticketdetail.vue?vue&type=template&id=545c8dfa&"
import script from "./ticketdetail.vue?vue&type=script&lang=js&"
export * from "./ticketdetail.vue?vue&type=script&lang=js&"
import style0 from "./ticketdetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports